/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ConciergeDataset,
  ConversationalAgentDataset,
  ConversationalAgentStateSchema,
  ConversationalAgentStateSchemaCreate,
  DatasetAudioRecording,
  DatasetDocument,
  DatasetPolymorphic,
  InformationExtractionDataset,
  InformationExtractionSchema,
  InformationExtractionSchemaCreate,
  PaginatedConciergeDatasetList,
  PaginatedConversationalAgentDatasetList,
  PaginatedDatasetAudioRecordingList,
  PaginatedDatasetDocumentList,
  PaginatedDatasetPolymorphicList,
  PaginatedInformationExtractionDatasetList,
  PaginatedPerturbationList,
  PaginatedSingleTurnChatDatasetList,
  PaginatedTabularMLDatasetList,
  PaginatedTextGenerationDatasetList,
  PaginatedVoiceAgentDatasetList,
  Perturbation,
  SingleTurnChatDataset,
  TabularMLDataset,
  TextGenerationDataset,
  VoiceAgentDataset,
} from '../models/index';
import {
  ConciergeDatasetFromJSON,
  ConciergeDatasetToJSON,
  ConversationalAgentDatasetFromJSON,
  ConversationalAgentDatasetToJSON,
  ConversationalAgentStateSchemaFromJSON,
  ConversationalAgentStateSchemaToJSON,
  ConversationalAgentStateSchemaCreateFromJSON,
  ConversationalAgentStateSchemaCreateToJSON,
  DatasetAudioRecordingFromJSON,
  DatasetAudioRecordingToJSON,
  DatasetDocumentFromJSON,
  DatasetDocumentToJSON,
  DatasetPolymorphicFromJSON,
  DatasetPolymorphicToJSON,
  InformationExtractionDatasetFromJSON,
  InformationExtractionDatasetToJSON,
  InformationExtractionSchemaFromJSON,
  InformationExtractionSchemaToJSON,
  InformationExtractionSchemaCreateFromJSON,
  InformationExtractionSchemaCreateToJSON,
  PaginatedConciergeDatasetListFromJSON,
  PaginatedConciergeDatasetListToJSON,
  PaginatedConversationalAgentDatasetListFromJSON,
  PaginatedConversationalAgentDatasetListToJSON,
  PaginatedDatasetAudioRecordingListFromJSON,
  PaginatedDatasetAudioRecordingListToJSON,
  PaginatedDatasetDocumentListFromJSON,
  PaginatedDatasetDocumentListToJSON,
  PaginatedDatasetPolymorphicListFromJSON,
  PaginatedDatasetPolymorphicListToJSON,
  PaginatedInformationExtractionDatasetListFromJSON,
  PaginatedInformationExtractionDatasetListToJSON,
  PaginatedPerturbationListFromJSON,
  PaginatedPerturbationListToJSON,
  PaginatedSingleTurnChatDatasetListFromJSON,
  PaginatedSingleTurnChatDatasetListToJSON,
  PaginatedTabularMLDatasetListFromJSON,
  PaginatedTabularMLDatasetListToJSON,
  PaginatedTextGenerationDatasetListFromJSON,
  PaginatedTextGenerationDatasetListToJSON,
  PaginatedVoiceAgentDatasetListFromJSON,
  PaginatedVoiceAgentDatasetListToJSON,
  PerturbationFromJSON,
  PerturbationToJSON,
  SingleTurnChatDatasetFromJSON,
  SingleTurnChatDatasetToJSON,
  TabularMLDatasetFromJSON,
  TabularMLDatasetToJSON,
  TextGenerationDatasetFromJSON,
  TextGenerationDatasetToJSON,
  VoiceAgentDatasetFromJSON,
  VoiceAgentDatasetToJSON,
} from '../models/index';

export interface ApiDatasetsAudioRecordingsCreateRequest {
  fileName: string;
  file: Blob;
}

export interface ApiDatasetsAudioRecordingsListRequest {
  fileName?: string;
  page?: number;
  pageSize?: number;
}

export interface ApiDatasetsAudioRecordingsRetrieveRequest {
  id: number;
}

export interface ApiDatasetsConciergeCreateRequest {
  rawData: Blob;
}

export interface ApiDatasetsConciergeListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDatasetsConciergeRetrieveRequest {
  id: number;
}

export interface ApiDatasetsConversationalAgentCreateRequest {
  datasetPath: Blob;
  language: string;
  stateSchema?: number | null;
  evaluateState?: boolean;
}

export interface ApiDatasetsConversationalAgentListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDatasetsConversationalAgentRetrieveRequest {
  id: number;
}

export interface ApiDatasetsConversationalAgentSeedCreateRequest {
  datasetPath: Blob;
  language: string;
  stateSchema?: number | null;
  evaluateState?: boolean;
}

export interface ApiDatasetsConversationalAgentSeedListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDatasetsConversationalAgentSeedRetrieveRequest {
  id: number;
}

export interface ApiDatasetsConversationalAgentStateSchemaCreateRequest {
  conversationalAgentStateSchemaCreate: ConversationalAgentStateSchemaCreate;
}

export interface ApiDatasetsDocumentsCreateRequest {
  fileName: string;
  file: Blob;
}

export interface ApiDatasetsDocumentsListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDatasetsDocumentsRetrieveRequest {
  id: number;
}

export interface ApiDatasetsInformationExtractionCreateRequest {
  datasetPath: Blob;
  schema: number;
  language: string;
  documents?: Array<number>;
}

export interface ApiDatasetsInformationExtractionListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDatasetsInformationExtractionRetrieveRequest {
  id: number;
}

export interface ApiDatasetsInformationExtractionSchemaCreateRequest {
  informationExtractionSchemaCreate: InformationExtractionSchemaCreate;
}

export interface ApiDatasetsListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDatasetsRetrieveRequest {
  id: number;
}

export interface ApiDatasetsSingleTurnChatCreateRequest {
  datasetPath: Blob;
  language: string;
  groundTruthIsExhaustive?: boolean;
}

export interface ApiDatasetsSingleTurnChatListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDatasetsSingleTurnChatRetrieveRequest {
  id: number;
}

export interface ApiDatasetsStateSchemasCreateRequest {
  conversationalAgentStateSchemaCreate: ConversationalAgentStateSchemaCreate;
}

export interface ApiDatasetsTabularMlCreateRequest {
  datasetPath: Blob;
  modelClass: string;
}

export interface ApiDatasetsTabularMlListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDatasetsTabularMlRetrieveRequest {
  id: number;
}

export interface ApiDatasetsTextGenerationCreateRequest {
  datasetPath: Blob;
  documents?: Array<number>;
}

export interface ApiDatasetsTextGenerationListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDatasetsTextGenerationRetrieveRequest {
  id: number;
}

export interface ApiDatasetsVoiceAgentCreateRequest {
  datasetPath: Blob;
  language: string;
  stateSchema?: number | null;
  evaluateState?: boolean;
  audioRecordings?: Array<number>;
}

export interface ApiDatasetsVoiceAgentListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDatasetsVoiceAgentRetrieveRequest {
  id: number;
}

export interface ApiDatasetsVoiceAgentSeedCreateRequest {
  datasetPath: Blob;
  language: string;
  stateSchema?: number | null;
  evaluateState?: boolean;
}

export interface ApiDatasetsVoiceAgentSeedListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDatasetsVoiceAgentSeedRetrieveRequest {
  id: number;
}

export interface ApiPerturbationsListRequest {
  isActive?: boolean;
  page?: number;
  pageSize?: number;
  taskType?: Array<ApiPerturbationsListTaskTypeEnum>;
}

export interface ApiPerturbationsRetrieveRequest {
  id: number;
}

/**
 *
 */
export class DatasetsApi extends runtime.BaseAPI {
  /**
   */
  async apiDatasetsAudioRecordingsCreateRaw(
    requestParameters: ApiDatasetsAudioRecordingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DatasetAudioRecording>> {
    if (requestParameters['fileName'] == null) {
      throw new runtime.RequiredError(
        'fileName',
        'Required parameter "fileName" was null or undefined when calling apiDatasetsAudioRecordingsCreate().',
      );
    }

    if (requestParameters['file'] == null) {
      throw new runtime.RequiredError(
        'file',
        'Required parameter "file" was null or undefined when calling apiDatasetsAudioRecordingsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
      { contentType: 'application/x-www-form-urlencoded' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['fileName'] != null) {
      formParams.append('file_name', requestParameters['fileName'] as any);
    }

    if (requestParameters['file'] != null) {
      formParams.append('file', requestParameters['file'] as any);
    }

    const response = await this.request(
      {
        path: `/api/datasets/audio-recordings/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DatasetAudioRecordingFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsAudioRecordingsCreate(
    requestParameters: ApiDatasetsAudioRecordingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DatasetAudioRecording> {
    const response = await this.apiDatasetsAudioRecordingsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsAudioRecordingsListRaw(
    requestParameters: ApiDatasetsAudioRecordingsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedDatasetAudioRecordingList>> {
    const queryParameters: any = {};

    if (requestParameters['fileName'] != null) {
      queryParameters['file_name'] = requestParameters['fileName'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/audio-recordings/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedDatasetAudioRecordingListFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsAudioRecordingsList(
    requestParameters: ApiDatasetsAudioRecordingsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedDatasetAudioRecordingList> {
    const response = await this.apiDatasetsAudioRecordingsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsAudioRecordingsRetrieveRaw(
    requestParameters: ApiDatasetsAudioRecordingsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DatasetAudioRecording>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetsAudioRecordingsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/audio-recordings/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DatasetAudioRecordingFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsAudioRecordingsRetrieve(
    requestParameters: ApiDatasetsAudioRecordingsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DatasetAudioRecording> {
    const response = await this.apiDatasetsAudioRecordingsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsConciergeCreateRaw(
    requestParameters: ApiDatasetsConciergeCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConciergeDataset>> {
    if (requestParameters['rawData'] == null) {
      throw new runtime.RequiredError(
        'rawData',
        'Required parameter "rawData" was null or undefined when calling apiDatasetsConciergeCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
      { contentType: 'application/x-www-form-urlencoded' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['rawData'] != null) {
      formParams.append('raw_data', requestParameters['rawData'] as any);
    }

    const response = await this.request(
      {
        path: `/api/datasets/concierge/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ConciergeDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsConciergeCreate(
    requestParameters: ApiDatasetsConciergeCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConciergeDataset> {
    const response = await this.apiDatasetsConciergeCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsConciergeListRaw(
    requestParameters: ApiDatasetsConciergeListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedConciergeDatasetList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/concierge/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedConciergeDatasetListFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsConciergeList(
    requestParameters: ApiDatasetsConciergeListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedConciergeDatasetList> {
    const response = await this.apiDatasetsConciergeListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsConciergeRetrieveRaw(
    requestParameters: ApiDatasetsConciergeRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConciergeDataset>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetsConciergeRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/concierge/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ConciergeDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsConciergeRetrieve(
    requestParameters: ApiDatasetsConciergeRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConciergeDataset> {
    const response = await this.apiDatasetsConciergeRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsConversationalAgentCreateRaw(
    requestParameters: ApiDatasetsConversationalAgentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentDataset>> {
    if (requestParameters['datasetPath'] == null) {
      throw new runtime.RequiredError(
        'datasetPath',
        'Required parameter "datasetPath" was null or undefined when calling apiDatasetsConversationalAgentCreate().',
      );
    }

    if (requestParameters['language'] == null) {
      throw new runtime.RequiredError(
        'language',
        'Required parameter "language" was null or undefined when calling apiDatasetsConversationalAgentCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
      { contentType: 'application/x-www-form-urlencoded' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['datasetPath'] != null) {
      formParams.append('dataset_path', requestParameters['datasetPath'] as any);
    }

    if (requestParameters['stateSchema'] != null) {
      formParams.append('state_schema', requestParameters['stateSchema'] as any);
    }

    if (requestParameters['evaluateState'] != null) {
      formParams.append('evaluate_state', requestParameters['evaluateState'] as any);
    }

    if (requestParameters['language'] != null) {
      formParams.append('language', requestParameters['language'] as any);
    }

    const response = await this.request(
      {
        path: `/api/datasets/conversational-agent/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ConversationalAgentDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsConversationalAgentCreate(
    requestParameters: ApiDatasetsConversationalAgentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentDataset> {
    const response = await this.apiDatasetsConversationalAgentCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsConversationalAgentListRaw(
    requestParameters: ApiDatasetsConversationalAgentListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedConversationalAgentDatasetList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/conversational-agent/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedConversationalAgentDatasetListFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiDatasetsConversationalAgentList(
    requestParameters: ApiDatasetsConversationalAgentListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedConversationalAgentDatasetList> {
    const response = await this.apiDatasetsConversationalAgentListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsConversationalAgentRetrieveRaw(
    requestParameters: ApiDatasetsConversationalAgentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentDataset>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetsConversationalAgentRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/conversational-agent/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ConversationalAgentDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsConversationalAgentRetrieve(
    requestParameters: ApiDatasetsConversationalAgentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentDataset> {
    const response = await this.apiDatasetsConversationalAgentRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsConversationalAgentSeedCreateRaw(
    requestParameters: ApiDatasetsConversationalAgentSeedCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentDataset>> {
    if (requestParameters['datasetPath'] == null) {
      throw new runtime.RequiredError(
        'datasetPath',
        'Required parameter "datasetPath" was null or undefined when calling apiDatasetsConversationalAgentSeedCreate().',
      );
    }

    if (requestParameters['language'] == null) {
      throw new runtime.RequiredError(
        'language',
        'Required parameter "language" was null or undefined when calling apiDatasetsConversationalAgentSeedCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
      { contentType: 'application/x-www-form-urlencoded' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['datasetPath'] != null) {
      formParams.append('dataset_path', requestParameters['datasetPath'] as any);
    }

    if (requestParameters['stateSchema'] != null) {
      formParams.append('state_schema', requestParameters['stateSchema'] as any);
    }

    if (requestParameters['evaluateState'] != null) {
      formParams.append('evaluate_state', requestParameters['evaluateState'] as any);
    }

    if (requestParameters['language'] != null) {
      formParams.append('language', requestParameters['language'] as any);
    }

    const response = await this.request(
      {
        path: `/api/datasets/conversational-agent/seed/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ConversationalAgentDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsConversationalAgentSeedCreate(
    requestParameters: ApiDatasetsConversationalAgentSeedCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentDataset> {
    const response = await this.apiDatasetsConversationalAgentSeedCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsConversationalAgentSeedListRaw(
    requestParameters: ApiDatasetsConversationalAgentSeedListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedConversationalAgentDatasetList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/conversational-agent/seed/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedConversationalAgentDatasetListFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiDatasetsConversationalAgentSeedList(
    requestParameters: ApiDatasetsConversationalAgentSeedListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedConversationalAgentDatasetList> {
    const response = await this.apiDatasetsConversationalAgentSeedListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsConversationalAgentSeedRetrieveRaw(
    requestParameters: ApiDatasetsConversationalAgentSeedRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentDataset>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetsConversationalAgentSeedRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/conversational-agent/seed/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ConversationalAgentDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsConversationalAgentSeedRetrieve(
    requestParameters: ApiDatasetsConversationalAgentSeedRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentDataset> {
    const response = await this.apiDatasetsConversationalAgentSeedRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Deprecated -- use POST /api/datasets/state-schemas/ instead. State schemas are shared across task types (conversational_agent, voice_agent), not CA-specific; this path is kept for backwards compatibility only.
   * @deprecated
   */
  async apiDatasetsConversationalAgentStateSchemaCreateRaw(
    requestParameters: ApiDatasetsConversationalAgentStateSchemaCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentStateSchema>> {
    if (requestParameters['conversationalAgentStateSchemaCreate'] == null) {
      throw new runtime.RequiredError(
        'conversationalAgentStateSchemaCreate',
        'Required parameter "conversationalAgentStateSchemaCreate" was null or undefined when calling apiDatasetsConversationalAgentStateSchemaCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/conversational-agent/state-schema/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ConversationalAgentStateSchemaCreateToJSON(requestParameters['conversationalAgentStateSchemaCreate']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ConversationalAgentStateSchemaFromJSON(jsonValue));
  }

  /**
   * Deprecated -- use POST /api/datasets/state-schemas/ instead. State schemas are shared across task types (conversational_agent, voice_agent), not CA-specific; this path is kept for backwards compatibility only.
   * @deprecated
   */
  async apiDatasetsConversationalAgentStateSchemaCreate(
    requestParameters: ApiDatasetsConversationalAgentStateSchemaCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentStateSchema> {
    const response = await this.apiDatasetsConversationalAgentStateSchemaCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsDocumentsCreateRaw(
    requestParameters: ApiDatasetsDocumentsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DatasetDocument>> {
    if (requestParameters['fileName'] == null) {
      throw new runtime.RequiredError(
        'fileName',
        'Required parameter "fileName" was null or undefined when calling apiDatasetsDocumentsCreate().',
      );
    }

    if (requestParameters['file'] == null) {
      throw new runtime.RequiredError(
        'file',
        'Required parameter "file" was null or undefined when calling apiDatasetsDocumentsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
      { contentType: 'application/x-www-form-urlencoded' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['fileName'] != null) {
      formParams.append('file_name', requestParameters['fileName'] as any);
    }

    if (requestParameters['file'] != null) {
      formParams.append('file', requestParameters['file'] as any);
    }

    const response = await this.request(
      {
        path: `/api/datasets/documents/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DatasetDocumentFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsDocumentsCreate(
    requestParameters: ApiDatasetsDocumentsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DatasetDocument> {
    const response = await this.apiDatasetsDocumentsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsDocumentsListRaw(
    requestParameters: ApiDatasetsDocumentsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedDatasetDocumentList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/documents/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedDatasetDocumentListFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsDocumentsList(
    requestParameters: ApiDatasetsDocumentsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedDatasetDocumentList> {
    const response = await this.apiDatasetsDocumentsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsDocumentsRetrieveRaw(
    requestParameters: ApiDatasetsDocumentsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DatasetDocument>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetsDocumentsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/documents/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DatasetDocumentFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsDocumentsRetrieve(
    requestParameters: ApiDatasetsDocumentsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DatasetDocument> {
    const response = await this.apiDatasetsDocumentsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsInformationExtractionCreateRaw(
    requestParameters: ApiDatasetsInformationExtractionCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InformationExtractionDataset>> {
    if (requestParameters['datasetPath'] == null) {
      throw new runtime.RequiredError(
        'datasetPath',
        'Required parameter "datasetPath" was null or undefined when calling apiDatasetsInformationExtractionCreate().',
      );
    }

    if (requestParameters['schema'] == null) {
      throw new runtime.RequiredError(
        'schema',
        'Required parameter "schema" was null or undefined when calling apiDatasetsInformationExtractionCreate().',
      );
    }

    if (requestParameters['language'] == null) {
      throw new runtime.RequiredError(
        'language',
        'Required parameter "language" was null or undefined when calling apiDatasetsInformationExtractionCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
      { contentType: 'application/x-www-form-urlencoded' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['datasetPath'] != null) {
      formParams.append('dataset_path', requestParameters['datasetPath'] as any);
    }

    if (requestParameters['documents'] != null) {
      requestParameters['documents'].forEach(element => {
        formParams.append('documents', element as any);
      });
    }

    if (requestParameters['schema'] != null) {
      formParams.append('schema', requestParameters['schema'] as any);
    }

    if (requestParameters['language'] != null) {
      formParams.append('language', requestParameters['language'] as any);
    }

    const response = await this.request(
      {
        path: `/api/datasets/information-extraction/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => InformationExtractionDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsInformationExtractionCreate(
    requestParameters: ApiDatasetsInformationExtractionCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InformationExtractionDataset> {
    const response = await this.apiDatasetsInformationExtractionCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsInformationExtractionListRaw(
    requestParameters: ApiDatasetsInformationExtractionListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedInformationExtractionDatasetList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/information-extraction/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedInformationExtractionDatasetListFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiDatasetsInformationExtractionList(
    requestParameters: ApiDatasetsInformationExtractionListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedInformationExtractionDatasetList> {
    const response = await this.apiDatasetsInformationExtractionListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsInformationExtractionRetrieveRaw(
    requestParameters: ApiDatasetsInformationExtractionRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InformationExtractionDataset>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetsInformationExtractionRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/information-extraction/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => InformationExtractionDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsInformationExtractionRetrieve(
    requestParameters: ApiDatasetsInformationExtractionRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InformationExtractionDataset> {
    const response = await this.apiDatasetsInformationExtractionRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsInformationExtractionSchemaCreateRaw(
    requestParameters: ApiDatasetsInformationExtractionSchemaCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InformationExtractionSchema>> {
    if (requestParameters['informationExtractionSchemaCreate'] == null) {
      throw new runtime.RequiredError(
        'informationExtractionSchemaCreate',
        'Required parameter "informationExtractionSchemaCreate" was null or undefined when calling apiDatasetsInformationExtractionSchemaCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/information-extraction/schema/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: InformationExtractionSchemaCreateToJSON(requestParameters['informationExtractionSchemaCreate']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => InformationExtractionSchemaFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsInformationExtractionSchemaCreate(
    requestParameters: ApiDatasetsInformationExtractionSchemaCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InformationExtractionSchema> {
    const response = await this.apiDatasetsInformationExtractionSchemaCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsListRaw(
    requestParameters: ApiDatasetsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedDatasetPolymorphicList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedDatasetPolymorphicListFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsList(
    requestParameters: ApiDatasetsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedDatasetPolymorphicList> {
    const response = await this.apiDatasetsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsRetrieveRaw(
    requestParameters: ApiDatasetsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DatasetPolymorphic>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DatasetPolymorphicFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsRetrieve(
    requestParameters: ApiDatasetsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DatasetPolymorphic> {
    const response = await this.apiDatasetsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsSingleTurnChatCreateRaw(
    requestParameters: ApiDatasetsSingleTurnChatCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SingleTurnChatDataset>> {
    if (requestParameters['datasetPath'] == null) {
      throw new runtime.RequiredError(
        'datasetPath',
        'Required parameter "datasetPath" was null or undefined when calling apiDatasetsSingleTurnChatCreate().',
      );
    }

    if (requestParameters['language'] == null) {
      throw new runtime.RequiredError(
        'language',
        'Required parameter "language" was null or undefined when calling apiDatasetsSingleTurnChatCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
      { contentType: 'application/x-www-form-urlencoded' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['datasetPath'] != null) {
      formParams.append('dataset_path', requestParameters['datasetPath'] as any);
    }

    if (requestParameters['language'] != null) {
      formParams.append('language', requestParameters['language'] as any);
    }

    if (requestParameters['groundTruthIsExhaustive'] != null) {
      formParams.append('ground_truth_is_exhaustive', requestParameters['groundTruthIsExhaustive'] as any);
    }

    const response = await this.request(
      {
        path: `/api/datasets/single-turn-chat/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SingleTurnChatDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsSingleTurnChatCreate(
    requestParameters: ApiDatasetsSingleTurnChatCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SingleTurnChatDataset> {
    const response = await this.apiDatasetsSingleTurnChatCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsSingleTurnChatListRaw(
    requestParameters: ApiDatasetsSingleTurnChatListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedSingleTurnChatDatasetList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/single-turn-chat/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedSingleTurnChatDatasetListFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsSingleTurnChatList(
    requestParameters: ApiDatasetsSingleTurnChatListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedSingleTurnChatDatasetList> {
    const response = await this.apiDatasetsSingleTurnChatListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsSingleTurnChatRetrieveRaw(
    requestParameters: ApiDatasetsSingleTurnChatRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SingleTurnChatDataset>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetsSingleTurnChatRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/single-turn-chat/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SingleTurnChatDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsSingleTurnChatRetrieve(
    requestParameters: ApiDatasetsSingleTurnChatRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SingleTurnChatDataset> {
    const response = await this.apiDatasetsSingleTurnChatRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Neutral, task-type-agnostic endpoint for state schemas -- use this instead of the deprecated conversational-agent-namespaced route.
   */
  async apiDatasetsStateSchemasCreateRaw(
    requestParameters: ApiDatasetsStateSchemasCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentStateSchema>> {
    if (requestParameters['conversationalAgentStateSchemaCreate'] == null) {
      throw new runtime.RequiredError(
        'conversationalAgentStateSchemaCreate',
        'Required parameter "conversationalAgentStateSchemaCreate" was null or undefined when calling apiDatasetsStateSchemasCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/state-schemas/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ConversationalAgentStateSchemaCreateToJSON(requestParameters['conversationalAgentStateSchemaCreate']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ConversationalAgentStateSchemaFromJSON(jsonValue));
  }

  /**
   * Neutral, task-type-agnostic endpoint for state schemas -- use this instead of the deprecated conversational-agent-namespaced route.
   */
  async apiDatasetsStateSchemasCreate(
    requestParameters: ApiDatasetsStateSchemasCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentStateSchema> {
    const response = await this.apiDatasetsStateSchemasCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsTabularMlCreateRaw(
    requestParameters: ApiDatasetsTabularMlCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TabularMLDataset>> {
    if (requestParameters['datasetPath'] == null) {
      throw new runtime.RequiredError(
        'datasetPath',
        'Required parameter "datasetPath" was null or undefined when calling apiDatasetsTabularMlCreate().',
      );
    }

    if (requestParameters['modelClass'] == null) {
      throw new runtime.RequiredError(
        'modelClass',
        'Required parameter "modelClass" was null or undefined when calling apiDatasetsTabularMlCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
      { contentType: 'application/x-www-form-urlencoded' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['datasetPath'] != null) {
      formParams.append('dataset_path', requestParameters['datasetPath'] as any);
    }

    if (requestParameters['modelClass'] != null) {
      formParams.append('model_class', requestParameters['modelClass'] as any);
    }

    const response = await this.request(
      {
        path: `/api/datasets/tabular-ml/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => TabularMLDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsTabularMlCreate(
    requestParameters: ApiDatasetsTabularMlCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TabularMLDataset> {
    const response = await this.apiDatasetsTabularMlCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsTabularMlListRaw(
    requestParameters: ApiDatasetsTabularMlListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedTabularMLDatasetList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/tabular-ml/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedTabularMLDatasetListFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsTabularMlList(
    requestParameters: ApiDatasetsTabularMlListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedTabularMLDatasetList> {
    const response = await this.apiDatasetsTabularMlListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsTabularMlRetrieveRaw(
    requestParameters: ApiDatasetsTabularMlRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TabularMLDataset>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetsTabularMlRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/tabular-ml/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => TabularMLDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsTabularMlRetrieve(
    requestParameters: ApiDatasetsTabularMlRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TabularMLDataset> {
    const response = await this.apiDatasetsTabularMlRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsTextGenerationCreateRaw(
    requestParameters: ApiDatasetsTextGenerationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TextGenerationDataset>> {
    if (requestParameters['datasetPath'] == null) {
      throw new runtime.RequiredError(
        'datasetPath',
        'Required parameter "datasetPath" was null or undefined when calling apiDatasetsTextGenerationCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
      { contentType: 'application/x-www-form-urlencoded' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['datasetPath'] != null) {
      formParams.append('dataset_path', requestParameters['datasetPath'] as any);
    }

    if (requestParameters['documents'] != null) {
      requestParameters['documents'].forEach(element => {
        formParams.append('documents', element as any);
      });
    }

    const response = await this.request(
      {
        path: `/api/datasets/text-generation/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => TextGenerationDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsTextGenerationCreate(
    requestParameters: ApiDatasetsTextGenerationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TextGenerationDataset> {
    const response = await this.apiDatasetsTextGenerationCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsTextGenerationListRaw(
    requestParameters: ApiDatasetsTextGenerationListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedTextGenerationDatasetList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/text-generation/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedTextGenerationDatasetListFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsTextGenerationList(
    requestParameters: ApiDatasetsTextGenerationListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedTextGenerationDatasetList> {
    const response = await this.apiDatasetsTextGenerationListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsTextGenerationRetrieveRaw(
    requestParameters: ApiDatasetsTextGenerationRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TextGenerationDataset>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetsTextGenerationRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/text-generation/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => TextGenerationDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsTextGenerationRetrieve(
    requestParameters: ApiDatasetsTextGenerationRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TextGenerationDataset> {
    const response = await this.apiDatasetsTextGenerationRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsVoiceAgentCreateRaw(
    requestParameters: ApiDatasetsVoiceAgentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<VoiceAgentDataset>> {
    if (requestParameters['datasetPath'] == null) {
      throw new runtime.RequiredError(
        'datasetPath',
        'Required parameter "datasetPath" was null or undefined when calling apiDatasetsVoiceAgentCreate().',
      );
    }

    if (requestParameters['language'] == null) {
      throw new runtime.RequiredError(
        'language',
        'Required parameter "language" was null or undefined when calling apiDatasetsVoiceAgentCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
      { contentType: 'application/x-www-form-urlencoded' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['datasetPath'] != null) {
      formParams.append('dataset_path', requestParameters['datasetPath'] as any);
    }

    if (requestParameters['stateSchema'] != null) {
      formParams.append('state_schema', requestParameters['stateSchema'] as any);
    }

    if (requestParameters['evaluateState'] != null) {
      formParams.append('evaluate_state', requestParameters['evaluateState'] as any);
    }

    if (requestParameters['language'] != null) {
      formParams.append('language', requestParameters['language'] as any);
    }

    if (requestParameters['audioRecordings'] != null) {
      requestParameters['audioRecordings'].forEach(element => {
        formParams.append('audio_recordings', element as any);
      });
    }

    const response = await this.request(
      {
        path: `/api/datasets/voice-agent/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => VoiceAgentDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsVoiceAgentCreate(
    requestParameters: ApiDatasetsVoiceAgentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<VoiceAgentDataset> {
    const response = await this.apiDatasetsVoiceAgentCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsVoiceAgentListRaw(
    requestParameters: ApiDatasetsVoiceAgentListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedVoiceAgentDatasetList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/voice-agent/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedVoiceAgentDatasetListFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsVoiceAgentList(
    requestParameters: ApiDatasetsVoiceAgentListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedVoiceAgentDatasetList> {
    const response = await this.apiDatasetsVoiceAgentListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsVoiceAgentRetrieveRaw(
    requestParameters: ApiDatasetsVoiceAgentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<VoiceAgentDataset>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetsVoiceAgentRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/voice-agent/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => VoiceAgentDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsVoiceAgentRetrieve(
    requestParameters: ApiDatasetsVoiceAgentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<VoiceAgentDataset> {
    const response = await this.apiDatasetsVoiceAgentRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsVoiceAgentSeedCreateRaw(
    requestParameters: ApiDatasetsVoiceAgentSeedCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<VoiceAgentDataset>> {
    if (requestParameters['datasetPath'] == null) {
      throw new runtime.RequiredError(
        'datasetPath',
        'Required parameter "datasetPath" was null or undefined when calling apiDatasetsVoiceAgentSeedCreate().',
      );
    }

    if (requestParameters['language'] == null) {
      throw new runtime.RequiredError(
        'language',
        'Required parameter "language" was null or undefined when calling apiDatasetsVoiceAgentSeedCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
      { contentType: 'application/x-www-form-urlencoded' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['datasetPath'] != null) {
      formParams.append('dataset_path', requestParameters['datasetPath'] as any);
    }

    if (requestParameters['stateSchema'] != null) {
      formParams.append('state_schema', requestParameters['stateSchema'] as any);
    }

    if (requestParameters['evaluateState'] != null) {
      formParams.append('evaluate_state', requestParameters['evaluateState'] as any);
    }

    if (requestParameters['language'] != null) {
      formParams.append('language', requestParameters['language'] as any);
    }

    const response = await this.request(
      {
        path: `/api/datasets/voice-agent/seed/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => VoiceAgentDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsVoiceAgentSeedCreate(
    requestParameters: ApiDatasetsVoiceAgentSeedCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<VoiceAgentDataset> {
    const response = await this.apiDatasetsVoiceAgentSeedCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsVoiceAgentSeedListRaw(
    requestParameters: ApiDatasetsVoiceAgentSeedListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedVoiceAgentDatasetList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/voice-agent/seed/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedVoiceAgentDatasetListFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsVoiceAgentSeedList(
    requestParameters: ApiDatasetsVoiceAgentSeedListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedVoiceAgentDatasetList> {
    const response = await this.apiDatasetsVoiceAgentSeedListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDatasetsVoiceAgentSeedRetrieveRaw(
    requestParameters: ApiDatasetsVoiceAgentSeedRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<VoiceAgentDataset>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetsVoiceAgentSeedRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/datasets/voice-agent/seed/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => VoiceAgentDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiDatasetsVoiceAgentSeedRetrieve(
    requestParameters: ApiDatasetsVoiceAgentSeedRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<VoiceAgentDataset> {
    const response = await this.apiDatasetsVoiceAgentSeedRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiPerturbationsListRaw(
    requestParameters: ApiPerturbationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedPerturbationList>> {
    const queryParameters: any = {};

    if (requestParameters['isActive'] != null) {
      queryParameters['is_active'] = requestParameters['isActive'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    if (requestParameters['taskType'] != null) {
      queryParameters['task_type'] = requestParameters['taskType'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/perturbations/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedPerturbationListFromJSON(jsonValue));
  }

  /**
   */
  async apiPerturbationsList(
    requestParameters: ApiPerturbationsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedPerturbationList> {
    const response = await this.apiPerturbationsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiPerturbationsRetrieveRaw(
    requestParameters: ApiPerturbationsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Perturbation>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiPerturbationsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/perturbations/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PerturbationFromJSON(jsonValue));
  }

  /**
   */
  async apiPerturbationsRetrieve(
    requestParameters: ApiPerturbationsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Perturbation> {
    const response = await this.apiPerturbationsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const ApiPerturbationsListTaskTypeEnum = {
  concierge: 'concierge',
  conversationalAgent: 'conversational_agent',
  informationExtraction: 'information_extraction',
  singleTurnChat: 'single_turn_chat',
  tabularMl: 'tabular_ml',
  textGeneration: 'text_generation',
  voiceAgent: 'voice_agent',
} as const;
export type ApiPerturbationsListTaskTypeEnum =
  (typeof ApiPerturbationsListTaskTypeEnum)[keyof typeof ApiPerturbationsListTaskTypeEnum];
